import { useState } from 'react';

export const useBag = () => {
  const bagInitialState = {
    weight: '',
    gluten: '',
    idk: '',
    bug: '',
    protein: '',
    cp: '',
    nature: '',
    humidity: '',
    temperature: '',
    wheatType: '',
  };
  const [bag, setBag] = useState(bagInitialState);
  return { bag, setBag, bagInitialState };
};
